export const perhaps = (v1, v2) => v1 || v2;
export const perhaps3 = (v1, v2, v3) => v1 || v2 || v3;
export const perhaps4 = (v1, v2, v3, v4) => v1 || v2 || v3 || v4;
export const even = (v1, v2) => v1 && v2;
export const even3 = (v1, v2, v3) => v1 && v2 && v3;
export const ternaryExpression = (v1, v2, v3) => (v1 ? v2 : v3);
export const ternaryExpressionFunc = (v1, v2, v3) => (v1 ? v2() : v3());
export const notNull = (v1) => v1;
